import { HexEdge } from '@colonist/game-mechanic-validators';
export class PortEdge {
    get type() {
        return this.state.type;
    }
    get owner() {
        return this.state.owner;
    }
    constructor(state){
        this.state = state;
        this.hexEdge = new HexEdge(this.state.x, this.state.y, this.state.z);
    }
}
export class PortState {
    get portEdges() {
        return this._portEdges;
    }
    getPortEdgeAtLocation(hexEdge) {
        for (const port of this.portEdges){
            if (port.hexEdge.sameEdge(hexEdge)) return port;
        }
        return undefined;
    }
    addPortEdge(portEdge) {
        this._portEdges.push(portEdge);
        const index = this._portEdges.length - 1;
        this.portEdgeStates[index] = portEdge.state;
    }
    loadPorts() {
        for(const index in this.portEdgeStates){
            const portEdgeState = this.portEdgeStates[index];
            if (portEdgeState == undefined) continue;
            const portEdge = new PortEdge(portEdgeState);
            this._portEdges.push(portEdge);
        }
    }
    isPortOnEdge(hexEdge) {
        for (const portEdge of this.portEdges){
            if (portEdge.hexEdge.sameEdge(hexEdge)) return true;
        }
        return false;
    }
    constructor(portEdgeStates){
        this._portEdges = [];
        this.portEdgeStates = portEdgeStates;
        this.loadPorts();
    }
}
